import config from '../../../../config/config';
import React from 'react';
import {
    withStyles,
    MobileStepper,
    Paper,
    Typography,
    Button
} from '@material-ui/core';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';
import SwipeableViews from 'react-swipeable-views';


const tutorialSteps = [
    {
        label: 'Log in - InstanceID is first part of URL, Username&Password your login credentials.',
        imgPath:
            `${config.backend_domain}:${config.backend_port}/tutorials/1-login.png`,
    },
    {
        label: 'Elevate user to system administrator to enable adding OAuth keys.',
        imgPath:
            `${config.backend_domain}:${config.backend_port}/tutorials/2-elevate.png`,
    },
    {
        label: 'Enter OAuth in table search box and select Application Registry.',
        imgPath:
            `${config.backend_domain}:${config.backend_port}/tutorials/3-app-registry.png`,
    },
    {
        label: 'Add a new application.',
        imgPath:
            `${config.backend_domain}:${config.backend_port}/tutorials/4-new-app.png`,
    },
    {
        label: 'Select API endpoint.',
        imgPath:
            `${config.backend_domain}:${config.backend_port}/tutorials/5-api-endpoint.png`,
    },
    {
        label: 'Configure parameters as on image or however you wish and create new app.',
        imgPath:
            `${config.backend_domain}:${config.backend_port}/tutorials/6-conf.png`,
    },
    {
        label: 'Select newly created app.',
        imgPath:
            `${config.backend_domain}:${config.backend_port}/tutorials/7-select-edit.png`,
    },
    {
        label: 'Toggle password visibility to get client secret.',
        imgPath:
            `${config.backend_domain}:${config.backend_port}/tutorials/8-toggle-secret.png`,
    },
    {
        label: 'Copy Client ID and Client Secret to Securaze form.',
        imgPath:
            `${config.backend_domain}:${config.backend_port}/tutorials/9-client-id-secret.png`,
    },
];

const styles = theme => ({
    root: {
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    button: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    formControl: {
    },
    img: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        height: '70%',
        width: '70%'
    },
    header: {
        textAlign: 'center'
    }
});

const HelpStepper = props => {
    const {
        classes,
    } = props;

    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = tutorialSteps.length;

    const handleNext = () => {
        setActiveStep(prevActiveStep => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1);
    };

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    return (
        <div>
            <Paper square elevation={0} className={classes.header}>
                <Typography>{tutorialSteps[activeStep].label}</Typography>
            </Paper>
            <SwipeableViews
                axis={'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
            >
                {tutorialSteps.map((step, index) => (
                    <div key={step.label}>
                        {Math.abs(activeStep - index) <= 2 ? (
                            <img className={classes.img} src={step.imgPath} alt={step.label} />
                        ) : null}
                    </div>
                ))}
            </SwipeableViews>
            <MobileStepper
                steps={maxSteps}
                position="static"
                variant="dots"
                activeStep={activeStep}
                nextButton={
                    <Button size="small" color={'primary'} variant={"contained"} className={classes.button} onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                        NEXT
            <KeyboardArrowRight />
                    </Button>
                }
                backButton={
                    <Button size="small" color={'primary'} variant={"contained"} className={classes.button} onClick={handleBack} disabled={activeStep === 0}>
                        <KeyboardArrowLeft />
            BACK
          </Button>
                }
            />
        </div>
    );
}

export default withStyles(styles, { withTheme: true })(HelpStepper);
